import '../services.css';

const SocialMediaMarketing = () => {
    return (
        <div className="cover w-100">
            {/* Hero Section */}
            <div className="service-hero-section text-white py-5 text-center bg-primary">
                <h1 className="display-4 fw-bold mb-3">Social Media Marketing</h1>

            </div>

            {/* Web Development Section */}
            <div className="container py-5">
                <div className="row align-items-center">
                    {/* Left - Text */}
                    <div className="col-md-8 mb-4 mb-md-0">
                        <p className="text-justify">
                            We provide full-service social media management. As a result, we enhance your social media profile through high-quality material, daily activity, monitoring-engagement, and increasing followers. This solution will attract targeted followers, who will eventually convert into devoted customers and provide brand loyalty.
                        </p>
                    </div>

                    {/* Right - Image */}
                    <div className="image-area col-md-4 text-center text-md-end h-100">
                        <img
                            src="assets\images\service\socialmedia.png"
                            alt="Social Media Marketing"
                            style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                        />
                    </div>
                </div>
            </div>

            {/* SOCIAL MEDIA ADVERTISING SERVICES */}
            <div className="container py-2  ">
                {/* Unique Web Design */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">SOCIAL MEDIA ADVERTISING SERVICES</h3>
                    <p className="text-justify">
                        Our social media advertising services have been tested and proved to drive growth and work well in conjunction with our social media management service. As a result, when our clients use our services to build social advertisements, they typically receive better results at a lesser cost.
                    </p>
                    <p className="text-justify">
                        While Facebook advertising is the most commonly used feature of this business, we can also run Instagram ads, LinkedIn ads, and other paid social ads. This solution makes use of your advertising spend to broaden your reach and direct targeted social media users to your website or landing page, all while tracking conversions and evaluating the metrics that matter.
                    </p>
                </div>

                {/* EMAIL AND SMS MARKETING SERVICES */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">EMAIL AND SMS MARKETING SERVICES</h3>
                    <p className="text-justify">
                        Every day, your consumers check their email. Our email marketing services will keep you at the top of your prospects' minds and shorten your sales cycle. You can anticipate excellent content that leads prospects through your sales funnel to buy, whether we generate weekly newsletters to deliver to your subscribers or build up a drip sequence to send the proper automated emails at the right time.
                    </p>
                </div>

                {/* SEARCH ENGINE OPTIMIZATION SERVICES */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">SEARCH ENGINE OPTIMIZATION SERVICES</h3>
                    <p className="text-justify">
                        With our SEO services, you will be seen on search engines like Google, Bing, and Amazon for relevant queries. Does your website appear when someone types a search term relating to your product or service into one of those search engines? Through higher organic ranks, our search engine optimization marketing service and content marketing will deliver more quality clicks, leads, and sales.
                    </p>
                </div>

                {/* PPC MANAGEMENT SERVICES */}
                <div className="mb-5">
                    <h3 className="h4 fw-semibold mb-3">PPC MANAGEMENT SERVICES</h3>
                    <p className="text-justify">
                        Our PPC management services (also known as SEM or search engine marketing) stands for pay per click. Consider it the speedier, compensated version of SEO. With our pay per click management services, you can obtain immediate traffic to your website from search engines like Google, Bing, and Amazon by directly paying those search engines to place your website at the top of relevant search results.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default SocialMediaMarketing;
